module.exports = __webpack_public_path__ + "img/img17.ccc3439c.png";